document.addEventListener("DOMContentLoaded", () => {
  console.log("YouTube modal script loaded");

  const thumbnail = document.getElementById("youtubeThumbnail");
  const modal = document.getElementById("youtubeModal");
  const iframe = document.getElementById("youtubeFrame");
  const closeBtn = document.getElementById("youtubeClose");

  // 要素が存在しないときは中断（防御コード）
  if (!thumbnail || !modal || !iframe || !closeBtn) {
    console.warn("YouTube modal: some elements not found");
    return;
  }

  const youtubeUrl = modal.dataset.youtubeUrl;

  thumbnail.addEventListener("click", () => {
    console.log("Thumbnail clicked");

    // URLにパラメータを追加して関連動画やロゴを非表示
    const params = new URLSearchParams({
      autoplay: 1,
      rel: 0,
      modestbranding: 1
    });

    iframe.src = `${youtubeUrl}?${params.toString()}`;
    modal.style.display = "block";
  });

  closeBtn.addEventListener("click", () => {
    modal.style.display = "none";
    iframe.src = "";
  });

  window.addEventListener("click", (e) => {
    if (e.target === modal) {
      modal.style.display = "none";
      iframe.src = "";
    }
  });
});
